import client from './client';

// Thông báo hệ thống (chuông) — tải bù khi mở app / socket nối lại / tab hiện lại.
export const listNotifications = (since) =>
  client.get('/notifications', { params: since ? { since } : {} }).then((r) => r.data);

// ids = 'all' -> đánh dấu đọc tất cả; hoặc mảng nid.
export const markNotificationsRead = (ids) =>
  client.post('/notifications/read', ids === 'all' ? { all: true } : { ids }).then((r) => r.data);
